import { FormBase } from 'core/components';

export default class ChangeWarehouseShipByDateForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouseShipByDate',
					rules: 'required',
					label: 'CHANGEWAREHOUSESHIPBYDATE.WAREHOUSESHIPBYDATE',
				},
			],
		};
	}
}
